import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../Styles/style";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import AccordianMain from "../../Components/Accordian/Accordian";
const ManImg = styled.img`
width: 100%;
height: auto;
max-width: 500px;
`
const GridWrapper = styled(Grid)`
display: flex;
align-items: center;
`
const Section8_Team = () => {
  const theme = useTheme()
  return (
    <SectionWrapper  p="4rem 0" id="FAQ">
      <Container maxWidth="xl" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
            <SectionHeading fs="70px" p="20px 0" m="0" align="center" data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500"
              data-aos-offset="0"  fs599="40PX" fs399="40PX">
             FAQ
            </SectionHeading>
       <AccordianMain/>
      </Container>
    </SectionWrapper>
  )
};

export default Section8_Team;
